// import React, { useEffect, useState } from "react";
// import "./FinancialPerformance.css";
// import { useDispatch, useSelector } from "react-redux";
// import { useParams } from "react-router-dom";
// import {
//   submitCorporateAndOrgStructureFailure,
//   submitCorporateAndOrgStructureRequest,
// } from "../../../../store/features/actions/corporateAndOrgStructureActions";
// import {
//   getAllPageInsights,
//   getAllSubdimensionMatches,
// } from "../../../../services/commonService";
// import HeadlineFinancialMetrics from "./HeadlineFinancialMetrics";
// import PricingAndCostStrucures from "./PricingAndCostStructures";
// import InvestorGuidanceAndBoardCommentary from "./InvestorGuidanceAndBoardCommentary";
// import RevenueBreakdown from "./RevenueBreakdown";
// import TopRightActionLinks from "../TopRightActionLinks";
// import InsightBlock from "../InsightBlock";
// import GenericOverviewSideCard from "../../genericComponents/GenericOverviewSideCard";
// import AIChat from "../../Chat/AiChat";
// import GenericTableSkeleton from "../../skeletons/tableSkeleton/genericTableSkeleton";
// import KeyCompetitorsTable from "../KeyCompetitorsTable";
// import CompetitorHeatmapContainer from "../CompetitorHeatmapContainer";
// import GroupedBarChart from "../../GroupedBarChart";

// function FinancialPerformance({ activeSubKey }) {
//   const { clientName, competitorName } = useParams();
//   const [showConversationModal, setShowConversationModal] = useState(false);
//   const [pagePositives, setPagePositives] = useState([]);
//   const [pageNegatives, setPageNegatives] = useState([]);
//   const [pageSoWhat, setPageSoWhat] = useState([]);
//   const [headlineFinancialMetrics, setHeadlineFinancialMetrics] = useState([]);
//   const [pricingAndCostStructures, setPricingAndCostStructures] = useState([]);
//   const [
//     investorGuidanceAndBoardCommentary,
//     setInvestorGuidanceAndBoardCommentary,
//   ] = useState([]);
//   const [revenueBreakdown, setRevenueBreakdown] = useState([]);
//   const dispatch = useDispatch();

//   const { loading, data, error } = useSelector(
//     (state) => state.corporateAndOrgStructureReducer
//   );

//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   }, []);

//   const chartData = [
//     { year: "2019", gross: 25, operating: 14, net: 9 },
//     { year: "2020", gross: 25, operating: 14, net: 9 },
//     { year: "2021", gross: 25, operating: 14, net: 9 },
//     { year: "2022", gross: 25, operating: 14, net: 9 },
//   ];

//   useEffect(() => {
//     dispatch(
//       submitCorporateAndOrgStructureRequest(
//         "Financial Performance & Strategy",
//         clientName
//       )
//     );
//   }, []);

//   useEffect(() => {
//     const tempHeadlineFinMetrics = getAllSubdimensionMatches(
//       data,
//       "Headline Financial Metrics"
//     );
//     setHeadlineFinancialMetrics(tempHeadlineFinMetrics);

//     const tempPricingAndCostStructures = getAllSubdimensionMatches(
//       data,
//       "Pricing & Cost Structures"
//     );
//     setPricingAndCostStructures(tempPricingAndCostStructures);

//     const tempInvestorGuidanceAndBoardCommentary = getAllSubdimensionMatches(
//       data,
//       "Investor Guidance & Board Commentary"
//     );
//     setInvestorGuidanceAndBoardCommentary(
//       tempInvestorGuidanceAndBoardCommentary
//     );

//     const tempRevenueBreakdown = getAllSubdimensionMatches(
//       data,
//       "Revenue Breakdown"
//     );
//     setRevenueBreakdown(tempRevenueBreakdown);

//     const { positive, negative, sowhat } = getAllPageInsights(data);
//     setPagePositives(positive || []);
//     setPageNegatives(negative || []);
//     setPageSoWhat(sowhat || []);
//   }, [data]);

//   const handleAiConversation = () => console.log("AI conversation clicked");
//   const handleDownload = () => console.log("Download clicked");

//   const actions = [
//     {
//       type: "conversation",
//       title: "Conversation",
//       onClick: () => {
//         setShowConversationModal((prev) => !prev);
//       },
//     },
//     { type: "download", title: "Download", onClick: handleDownload },
//   ];

//   return (
//     <div className="financial_wrapper">
//       {/* {loading ? (
//         <GenericTableSkeleton colCount={3} rowCount={5} />
//       ) : (
//         <InsightBlock
//           title={"Financial Performance"}
//           overview={`Benchmarking ${
//             clientName ?? "HB Fuller"
//           }’s revenue performance, cost levers, investor confidence, and financial strategy against public peers like Henkel and Bostik.`}
//           actions={actions}
//           pagePositives={pagePositives}
//           pageNegatives={pageNegatives}
//           pageSoWhat={pageSoWhat}
//         />
//       )} */}

//       {/* <KeyCompetitorsTable ticker={"STZ:NYSE"} active_tab_key={activeSubKey} /> */}
//       <div className="px-3">
//         <CompetitorHeatmapContainer />
//       </div>

//       <div className="channel_contribution_block">
//         <GroupedBarChart data={chartData} />
//       </div>

//       {/* {loading ? (
//         <GenericTableSkeleton colCount={3} rowCount={5} />
//       ) : (
//         <HeadlineFinancialMetrics
//           headlineFinancialMetrics={headlineFinancialMetrics}
//         />
//       )}

//       {loading ? (
//         <GenericTableSkeleton colCount={3} rowCount={5} />
//       ) : (
//         <PricingAndCostStrucures
//           pricingAndCostStructures={pricingAndCostStructures}
//         />
//       )}

//       {loading ? (
//         <GenericTableSkeleton colCount={3} rowCount={5} />
//       ) : (
//         <InvestorGuidanceAndBoardCommentary
//           investorGuidanceAndBoardCommentary={
//             investorGuidanceAndBoardCommentary
//           }
//         />
//       )}

//       {loading ? (
//         <GenericTableSkeleton colCount={3} rowCount={5} />
//       ) : (
//         <RevenueBreakdown revenueBreakdown={revenueBreakdown} />
//       )} */}

//       {showConversationModal && (
//         <GenericOverviewSideCard
//           showMoreModal={showConversationModal}
//           setShowMoreModal={setShowConversationModal}
//           titleForSideCard={
//             <div className="ai_insight_top_block">
//               <div className="ai_insight_left">
//                 <div className="ai_insight_img">
//                   <img
//                     src="/img/ai_insight_top.png"
//                     alt="icon"
//                     className="ai_icon"
//                   />
//                 </div>
//                 <div className="ai_insight_text">
//                   <h5 className="ai_insight_top_head">
//                     Decode This:{" "}
//                     {competitorName ?? "Tailored Chemical Products"} - Market
//                     Insights
//                   </h5>
//                   <p className="ai_insight_top_subhead">
//                     AI-powered competitive intelligence and strategic insights
//                   </p>
//                 </div>
//               </div>
//               <div className="ai_insight_right"></div>
//             </div>
//           }
//           comp={<AIChat section={""} />}
//           minWidthForDrawer="40%"
//           disableXbtn={false}
//         />
//       )}
//     </div>
//   );
// }

// export default FinancialPerformance;

// import React, { useEffect, useState, useCallback, useRef } from "react";
// import "./FinancialPerformance.css";
// import { useDispatch, useSelector } from "react-redux";
// import { useParams } from "react-router-dom";
// import {
//   submitCorporateAndOrgStructureFailure,
//   submitCorporateAndOrgStructureRequest,
// } from "../../../../store/features/actions/corporateAndOrgStructureActions";
// import {
//   getAllPageInsights,
//   getAllSubdimensionMatches,
// } from "../../../../services/commonService";
// import {
//   fetchMultipleFinancials,
//   searchCompetitor,
//   saveUserHeatmapRecord,
//   getUserHeatmapRecord,
// } from "../../../../services/accIqService";
// import { submitCompetitorListRequest } from "../../../../store/features/actions/competitorListActions";
// import { useUser } from "../../../../context/UserContext";
// import APP_CONFIG from "../../../../config/appConfig";

// import HeadlineFinancialMetrics from "./HeadlineFinancialMetrics";
// import PricingAndCostStrucures from "./PricingAndCostStructures";
// import InvestorGuidanceAndBoardCommentary from "./InvestorGuidanceAndBoardCommentary";
// import RevenueBreakdown from "./RevenueBreakdown";
// import TopRightActionLinks from "../TopRightActionLinks";
// import InsightBlock from "../InsightBlock";
// import GenericOverviewSideCard from "../../genericComponents/GenericOverviewSideCard";
// import AIChat from "../../Chat/AiChat";
// import GenericTableSkeleton from "../../skeletons/tableSkeleton/genericTableSkeleton";
// import KeyCompetitorsTable from "../KeyCompetitorsTable";
// import CompetitorHeatmapContainer from "../CompetitorHeatmapContainer";
// import GroupedBarChart from "../../GroupedBarChart";

// const admin_roles = ["ROLE_MNM_SUBSCRIBER", "ROLE_ACCOUNT_MANAGER"];

// const DEFAULT_METRICS = [
//   "IQ_TOTAL_REV",
//   "IQ_GP",
//   "IQ_EBITDA",
//   "IQ_EBIT",
//   "IQ_NI",
//   "IQ_BASIC_EPS_INCL",
//   "IQ_TOTAL_ASSETS",
//   "IQ_TOTAL_CAP",
// ];

// const transformFinancialData = (apiResponse) => {
//   if (!apiResponse || !Array.isArray(apiResponse.rawFinancials)) return [];

//   return apiResponse.rawFinancials.map((metricBlock) => {
//     const sorted =
//       metricBlock.data
//         ?.filter((d) => d.value !== "Data Unavailable")
//         ?.sort((a, b) => Number(b.year) - Number(a.year)) || [];

//     return {
//       metric: metricBlock._id,
//       value: sorted.length ? Number(sorted[0].value) : null,
//     };
//   });
// };

// const mergeUniqueCompanies = (...arrays) => {
//   const map = new Map();
//   arrays.flat().forEach((item) => {
//     if (item?.value) map.set(item.value, item);
//   });
//   return Array.from(map.values());
// };

// function FinancialPerformance({ activeSubKey, selectedClient }) {
//   const { clientName, competitorName } = useParams();
//   const dispatch = useDispatch();
//   const { user } = useUser();

//   const initializedRef = useRef(false);

//   // ── page-level state (unchanged) ──────────────────────────────────────────
//   const [showConversationModal, setShowConversationModal] = useState(false);
//   const [pagePositives, setPagePositives] = useState([]);
//   const [pageNegatives, setPageNegatives] = useState([]);
//   const [pageSoWhat, setPageSoWhat] = useState([]);
//   const [headlineFinancialMetrics, setHeadlineFinancialMetrics] = useState([]);
//   const [pricingAndCostStructures, setPricingAndCostStructures] = useState([]);
//   const [
//     investorGuidanceAndBoardCommentary,
//     setInvestorGuidanceAndBoardCommentary,
//   ] = useState([]);
//   const [revenueBreakdown, setRevenueBreakdown] = useState([]);

//   // ── shared heatmap / bar-chart state (lifted from CompetitorHeatmapContainer) ──
//   const [selectedCompetitors, setSelectedCompetitors] = useState([]);
//   const [competitorOptions, setCompetitorOptions] = useState([]);
//   const [financialData, setFinancialData] = useState([]);
//   const [loadingFinancials, setLoadingFinancials] = useState(false);
//   const [selectedMetrics, setSelectedMetrics] = useState(DEFAULT_METRICS);

//   const resolvedClientName =
//     admin_roles.includes(user?.growth_iq_role_name) && selectedClient
//       ? selectedClient
//       : user?.company_name_for_growth_iq;

//   const { loading, data, error } = useSelector(
//     (state) => state.corporateAndOrgStructureReducer
//   );

//   const { data: competitorList } = useSelector(
//     (state) => state.competitorListReducer
//   );

//   const defaultCompetitors =
//     competitorList?.result?.map((comp) => ({
//       label: comp.company,
//       value: comp.vendor_company_id,
//     })) || [];

//   // ── scroll to top ─────────────────────────────────────────────────────────
//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   }, []);

//   // ── load page dimension data ──────────────────────────────────────────────
//   useEffect(() => {
//     dispatch(
//       submitCorporateAndOrgStructureRequest(
//         "Financial Performance & Strategy",
//         clientName
//       )
//     );
//   }, []);

//   useEffect(() => {
//     const tempHeadlineFinMetrics = getAllSubdimensionMatches(
//       data,
//       "Headline Financial Metrics"
//     );
//     setHeadlineFinancialMetrics(tempHeadlineFinMetrics);

//     const tempPricingAndCostStructures = getAllSubdimensionMatches(
//       data,
//       "Pricing & Cost Structures"
//     );
//     setPricingAndCostStructures(tempPricingAndCostStructures);

//     const tempInvestorGuidanceAndBoardCommentary = getAllSubdimensionMatches(
//       data,
//       "Investor Guidance & Board Commentary"
//     );
//     setInvestorGuidanceAndBoardCommentary(
//       tempInvestorGuidanceAndBoardCommentary
//     );

//     const tempRevenueBreakdown = getAllSubdimensionMatches(
//       data,
//       "Revenue Breakdown"
//     );
//     setRevenueBreakdown(tempRevenueBreakdown);

//     const { positive, negative, sowhat } = getAllPageInsights(data);
//     setPagePositives(positive || []);
//     setPageNegatives(negative || []);
//     setPageSoWhat(sowhat || []);
//   }, [data]);

//   // ── reset when client changes ─────────────────────────────────────────────
//   useEffect(() => {
//     initializedRef.current = false;
//     setSelectedCompetitors([]);
//     setCompetitorOptions([]);
//     setFinancialData([]);
//   }, [resolvedClientName]);

//   // ── load competitor list ──────────────────────────────────────────────────
//   useEffect(() => {
//     dispatch(
//       submitCompetitorListRequest({
//         client: resolvedClientName,
//         user_id: user?.user_id,
//         user_type:
//           user?.demo === APP_CONFIG.market_iq_demo ? "MarketIQ" : "CompIQ",
//         user_role: user?.growth_iq_role_name,
//       })
//     );
//   }, [resolvedClientName, user, dispatch]);

//   // ── fetch financials (shared, called from parent & passed down) ───────────
//   const fetchFinancials = useCallback(
//     async (competitorArg) => {
//       const list = Array.isArray(competitorArg)
//         ? competitorArg
//         : selectedCompetitors;

//       if (!list.length) return;

//       setLoadingFinancials(true);

//       try {
//         await saveUserHeatmapRecord({
//           user_id: user?.user_id,
//           client_name: resolvedClientName,
//           companies: list
//             .filter((item) => item?.value && item?.label)
//             .map((item) => ({
//               company_id: item.value,
//               company_name: item.label,
//             })),
//         });

//         const result = await fetchMultipleFinancials(list);

//         const merged = result.map((apiResp, index) => ({
//           vendor_company_id: list[index]?.value,
//           company_name: list[index]?.label,
//           metrics: transformFinancialData(apiResp),
//         }));

//         setFinancialData(merged);
//       } catch (error) {
//         console.error("Financial fetch error:", error);
//       }

//       setLoadingFinancials(false);
//     },
//     [selectedCompetitors, user, resolvedClientName]
//   );

//   // ── initial load: restore saved heatmap record ────────────────────────────
//   useEffect(() => {
//     if (initializedRef.current || !competitorList) return;

//     initializedRef.current = true;

//     const init = async () => {
//       const fallbackList = [...defaultCompetitors];

//       try {
//         const res = await getUserHeatmapRecord({
//           user_id: user?.user_id,
//           client_name: resolvedClientName,
//         });

//         const saved =
//           res?.companies?.map((item) => ({
//             value: item.company_id,
//             label: item.company_name,
//           })) || [];

//         if (saved.length) {
//           setSelectedCompetitors(saved);
//           setCompetitorOptions(mergeUniqueCompanies(saved, fallbackList));
//           fetchFinancials(saved);
//           return;
//         }

//         setSelectedCompetitors(fallbackList);
//         setCompetitorOptions(fallbackList);

//         if (fallbackList.length) {
//           fetchFinancials(fallbackList);
//         }
//       } catch (err) {
//         setSelectedCompetitors(fallbackList);
//         setCompetitorOptions(fallbackList);

//         if (fallbackList.length) {
//           fetchFinancials(fallbackList);
//         }
//       }
//     };

//     init();
//   }, [
//     competitorList,
//     defaultCompetitors,
//     user,
//     resolvedClientName,
//     fetchFinancials,
//   ]);

//   // ── action handlers (unchanged) ───────────────────────────────────────────
//   const handleAiConversation = () => console.log("AI conversation clicked");
//   const handleDownload = () => console.log("Download clicked");

//   const actions = [
//     {
//       type: "conversation",
//       title: "Conversation",
//       onClick: () => {
//         setShowConversationModal((prev) => !prev);
//       },
//     },
//     { type: "download", title: "Download", onClick: handleDownload },
//   ];

//   return (
//     <div className="financial_wrapper">
//       <div className="px-3">
//         {/* Pass all shared state & handlers down to CompetitorHeatmapContainer */}
//         <CompetitorHeatmapContainer
//           selectedClient={selectedClient}
//           // shared data from parent
//           selectedCompetitors={selectedCompetitors}
//           setSelectedCompetitors={setSelectedCompetitors}
//           competitorOptions={competitorOptions}
//           setCompetitorOptions={setCompetitorOptions}
//           financialData={financialData}
//           loadingFinancials={loadingFinancials}
//           selectedMetrics={selectedMetrics}
//           setSelectedMetrics={setSelectedMetrics}
//           fetchFinancials={fetchFinancials}
//           defaultCompetitors={defaultCompetitors}
//         />
//       </div>

//       <div className="channel_contribution_block">
//         {/* Pass master competitor/financial data down to GroupedBarChart */}
//         <GroupedBarChart
//           financialData={financialData}
//           competitorOptions={selectedCompetitors}
//         />
//       </div>
//     </div>
//   );
// }

// export default FinancialPerformance;

// import React, { useEffect, useState, useCallback, useRef } from "react";
// import "./FinancialPerformance.css";
// import { useDispatch, useSelector } from "react-redux";
// import { useParams } from "react-router-dom";
// import {
//   submitCorporateAndOrgStructureFailure,
//   submitCorporateAndOrgStructureRequest,
// } from "../../../../store/features/actions/corporateAndOrgStructureActions";
// import {
//   getAllPageInsights,
//   getAllSubdimensionMatches,
// } from "../../../../services/commonService";
// import {
//   fetchMultipleFinancials,
//   saveUserHeatmapRecord,
//   getUserHeatmapRecord,
// } from "../../../../services/accIqService";
// import { submitCompetitorListRequest } from "../../../../store/features/actions/competitorListActions";
// import { useUser } from "../../../../context/UserContext";
// import APP_CONFIG from "../../../../config/appConfig";

// import HeadlineFinancialMetrics from "./HeadlineFinancialMetrics";
// import PricingAndCostStrucures from "./PricingAndCostStructures";
// import InvestorGuidanceAndBoardCommentary from "./InvestorGuidanceAndBoardCommentary";
// import RevenueBreakdown from "./RevenueBreakdown";
// import TopRightActionLinks from "../TopRightActionLinks";
// import InsightBlock from "../InsightBlock";
// import GenericOverviewSideCard from "../../genericComponents/GenericOverviewSideCard";
// import AIChat from "../../Chat/AiChat";
// import GenericTableSkeleton from "../../skeletons/tableSkeleton/genericTableSkeleton";
// import KeyCompetitorsTable from "../KeyCompetitorsTable";
// import CompetitorHeatmapContainer from "../CompetitorHeatmapContainer";
// import GroupedBarChart from "../../GroupedBarChart";

// const admin_roles = ["ROLE_MNM_SUBSCRIBER", "ROLE_ACCOUNT_MANAGER"];

// const transformFinancialData = (apiResponse) => {
//   if (!apiResponse || !Array.isArray(apiResponse.rawFinancials)) return [];
//   return apiResponse.rawFinancials.map((metricBlock) => {
//     const sorted =
//       metricBlock.data
//         ?.filter((d) => d.value !== "Data Unavailable")
//         ?.sort((a, b) => Number(b.year) - Number(a.year)) || [];
//     return {
//       metric: metricBlock._id,
//       value: sorted.length ? Number(sorted[0].value) : null,
//     };
//   });
// };

// const mergeUniqueCompanies = (...arrays) => {
//   const map = new Map();
//   arrays.flat().forEach((item) => {
//     if (item?.value) map.set(item.value, item);
//   });
//   return Array.from(map.values());
// };

// function FinancialPerformance({ activeSubKey, selectedClient }) {
//   const { clientName, competitorName } = useParams();
//   const dispatch = useDispatch();
//   const { user } = useUser();
//   const initializedRef = useRef(false);

//   // ── page-level insight state ───────────────────────────────────────────────
//   const [showConversationModal, setShowConversationModal] = useState(false);
//   const [pagePositives, setPagePositives] = useState([]);
//   const [pageNegatives, setPageNegatives] = useState([]);
//   const [pageSoWhat, setPageSoWhat] = useState([]);
//   const [headlineFinancialMetrics, setHeadlineFinancialMetrics] = useState([]);
//   const [pricingAndCostStructures, setPricingAndCostStructures] = useState([]);
//   const [
//     investorGuidanceAndBoardCommentary,
//     setInvestorGuidanceAndBoardCommentary,
//   ] = useState([]);
//   const [revenueBreakdown, setRevenueBreakdown] = useState([]);

//   // ── master shared state (passed read-only to children) ────────────────────
//   // Each child manages its own local visual filter independently.
//   const [selectedCompetitors, setSelectedCompetitors] = useState([]);
//   const [competitorOptions, setCompetitorOptions] = useState([]);
//   const [financialData, setFinancialData] = useState([]);
//   const [loadingFinancials, setLoadingFinancials] = useState(false);

//   const resolvedClientName =
//     admin_roles.includes(user?.growth_iq_role_name) && selectedClient
//       ? selectedClient
//       : user?.company_name_for_growth_iq;

//   const { loading, data, error } = useSelector(
//     (state) => state.corporateAndOrgStructureReducer
//   );
//   const { data: competitorList } = useSelector(
//     (state) => state.competitorListReducer
//   );

//   const defaultCompetitors =
//     competitorList?.result?.map((comp) => ({
//       label: comp.company,
//       value: comp.vendor_company_id,
//     })) || [];

//   // ── scroll to top ─────────────────────────────────────────────────────────
//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   }, []);

//   // ── load page dimension data ──────────────────────────────────────────────
//   useEffect(() => {
//     dispatch(
//       submitCorporateAndOrgStructureRequest(
//         "Financial Performance & Strategy",
//         clientName
//       )
//     );
//   }, []);

//   useEffect(() => {
//     setHeadlineFinancialMetrics(
//       getAllSubdimensionMatches(data, "Headline Financial Metrics")
//     );
//     setPricingAndCostStructures(
//       getAllSubdimensionMatches(data, "Pricing & Cost Structures")
//     );
//     setInvestorGuidanceAndBoardCommentary(
//       getAllSubdimensionMatches(data, "Investor Guidance & Board Commentary")
//     );
//     setRevenueBreakdown(getAllSubdimensionMatches(data, "Revenue Breakdown"));
//     const { positive, negative, sowhat } = getAllPageInsights(data);
//     setPagePositives(positive || []);
//     setPageNegatives(negative || []);
//     setPageSoWhat(sowhat || []);
//   }, [data]);

//   // ── reset when client changes ─────────────────────────────────────────────
//   useEffect(() => {
//     initializedRef.current = false;
//     setSelectedCompetitors([]);
//     setCompetitorOptions([]);
//     setFinancialData([]);
//   }, [resolvedClientName]);

//   // ── load competitor list ──────────────────────────────────────────────────
//   useEffect(() => {
//     dispatch(
//       submitCompetitorListRequest({
//         client: resolvedClientName,
//         user_id: user?.user_id,
//         user_type:
//           user?.demo === APP_CONFIG.market_iq_demo ? "MarketIQ" : "CompIQ",
//         user_role: user?.growth_iq_role_name,
//       })
//     );
//   }, [resolvedClientName, user, dispatch]);

//   // ── fetch financials (owned here, triggered by heatmap generate button) ───
//   const fetchFinancials = useCallback(
//     async (competitorArg) => {
//       const list = Array.isArray(competitorArg)
//         ? competitorArg
//         : selectedCompetitors;
//       if (!list.length) return;

//       setLoadingFinancials(true);
//       try {
//         await saveUserHeatmapRecord({
//           user_id: user?.user_id,
//           client_name: resolvedClientName,
//           companies: list
//             .filter((item) => item?.value && item?.label)
//             .map((item) => ({
//               company_id: item.value,
//               company_name: item.label,
//             })),
//         });

//         const result = await fetchMultipleFinancials(list);
//         const merged = result.map((apiResp, index) => ({
//           vendor_company_id: list[index]?.value,
//           company_name: list[index]?.label,
//           metrics: transformFinancialData(apiResp),
//         }));
//         setFinancialData(merged);
//       } catch (err) {
//         console.error("Financial fetch error:", err);
//       }
//       setLoadingFinancials(false);
//     },
//     [selectedCompetitors, user, resolvedClientName]
//   );

//   // ── initial load: restore saved heatmap record ────────────────────────────
//   useEffect(() => {
//     if (initializedRef.current || !competitorList) return;
//     initializedRef.current = true;

//     const init = async () => {
//       const fallbackList = [...defaultCompetitors];
//       try {
//         const res = await getUserHeatmapRecord({
//           user_id: user?.user_id,
//           client_name: resolvedClientName,
//         });
//         const saved =
//           res?.companies?.map((item) => ({
//             value: item.company_id,
//             label: item.company_name,
//           })) || [];

//         if (saved.length) {
//           setSelectedCompetitors(saved);
//           setCompetitorOptions(mergeUniqueCompanies(saved, fallbackList));
//           fetchFinancials(saved);
//           return;
//         }
//         setSelectedCompetitors(fallbackList);
//         setCompetitorOptions(fallbackList);
//         if (fallbackList.length) fetchFinancials(fallbackList);
//       } catch (err) {
//         setSelectedCompetitors(fallbackList);
//         setCompetitorOptions(fallbackList);
//         if (fallbackList.length) fetchFinancials(fallbackList);
//       }
//     };

//     init();
//   }, [
//     competitorList,
//     defaultCompetitors,
//     user,
//     resolvedClientName,
//     fetchFinancials,
//   ]);

//   const handleAiConversation = () => console.log("AI conversation clicked");
//   const handleDownload = () => console.log("Download clicked");

//   const actions = [
//     {
//       type: "conversation",
//       title: "Conversation",
//       onClick: () => setShowConversationModal((prev) => !prev),
//     },
//     { type: "download", title: "Download", onClick: handleDownload },
//   ];

//   return (
//     <div className="financial_wrapper">
//       <div className="px-3">
//         {/*
//           CompetitorHeatmapContainer:
//           - master selector (selectedCompetitors / competitorOptions) stays here
//           - each child filters its own visual independently via local state
//         */}
//         <CompetitorHeatmapContainer
//           selectedClient={selectedClient}
//           // master selector state — drives what gets fetched
//           selectedCompetitors={selectedCompetitors}
//           setSelectedCompetitors={setSelectedCompetitors}
//           competitorOptions={competitorOptions}
//           setCompetitorOptions={setCompetitorOptions}
//           // fetched data
//           financialData={financialData}
//           loadingFinancials={loadingFinancials}
//           fetchFinancials={fetchFinancials}
//           defaultCompetitors={defaultCompetitors}
//         />
//       </div>

//       <div className="channel_contribution_block ">
//         {/*
//           GroupedBarChart:
//           - receives master financialData and selectedCompetitors as the pool
//           - manages its own local company + metric filters (only affects bar chart)
//         */}
//         <GroupedBarChart
//           financialData={financialData}
//           competitorOptions={selectedCompetitors}
//         />
//       </div>
//     </div>
//   );
// }

// export default FinancialPerformance;

// import React, { useEffect, useState, useCallback, useRef } from "react";
// import "./FinancialPerformance.css";
// import { useDispatch, useSelector } from "react-redux";
// import { useParams } from "react-router-dom";
// import {
//   submitCorporateAndOrgStructureFailure,
//   submitCorporateAndOrgStructureRequest,
// } from "../../../../store/features/actions/corporateAndOrgStructureActions";
// import {
//   getAllPageInsights,
//   getAllSubdimensionMatches,
// } from "../../../../services/commonService";
// import {
//   fetchMultipleFinancials,
//   saveUserHeatmapRecord,
//   getUserHeatmapRecord,
// } from "../../../../services/accIqService";
// import { submitCompetitorListRequest } from "../../../../store/features/actions/competitorListActions";
// import { useUser } from "../../../../context/UserContext";
// import APP_CONFIG from "../../../../config/appConfig";

// import HeadlineFinancialMetrics from "./HeadlineFinancialMetrics";
// import PricingAndCostStrucures from "./PricingAndCostStructures";
// import InvestorGuidanceAndBoardCommentary from "./InvestorGuidanceAndBoardCommentary";
// import RevenueBreakdown from "./RevenueBreakdown";
// import TopRightActionLinks from "../TopRightActionLinks";
// import InsightBlock from "../InsightBlock";
// import GenericOverviewSideCard from "../../genericComponents/GenericOverviewSideCard";
// import AIChat from "../../Chat/AiChat";
// import GenericTableSkeleton from "../../skeletons/tableSkeleton/genericTableSkeleton";
// import KeyCompetitorsTable from "../KeyCompetitorsTable";
// import CompetitorHeatmapContainer from "../CompetitorHeatmapContainer";
// import GroupedBarChart from "../../GroupedBarChart";

// const admin_roles = ["ROLE_MNM_SUBSCRIBER", "ROLE_ACCOUNT_MANAGER"];

// const transformFinancialData = (apiResponse) => {
//   if (!apiResponse || !Array.isArray(apiResponse.rawFinancials)) return [];
//   return apiResponse.rawFinancials.map((metricBlock) => {
//     const sorted =
//       metricBlock.data
//         ?.filter((d) => d.value !== "Data Unavailable")
//         ?.sort((a, b) => Number(b.year) - Number(a.year)) || [];
//     return {
//       metric: metricBlock._id,
//       value: sorted.length ? Number(sorted[0].value) : null,
//     };
//   });
// };

// const mergeUniqueCompanies = (...arrays) => {
//   const map = new Map();
//   arrays.flat().forEach((item) => {
//     if (item?.value) map.set(item.value, item);
//   });
//   return Array.from(map.values());
// };

// function FinancialPerformance({ activeSubKey, selectedClient }) {
//   const { clientName, competitorName } = useParams();
//   const dispatch = useDispatch();
//   const { user } = useUser();
//   const initializedRef = useRef(false);

//   // ── page-level insight state ───────────────────────────────────────────────
//   const [showConversationModal, setShowConversationModal] = useState(false);
//   const [pagePositives, setPagePositives] = useState([]);
//   const [pageNegatives, setPageNegatives] = useState([]);
//   const [pageSoWhat, setPageSoWhat] = useState([]);
//   const [headlineFinancialMetrics, setHeadlineFinancialMetrics] = useState([]);
//   const [pricingAndCostStructures, setPricingAndCostStructures] = useState([]);
//   const [
//     investorGuidanceAndBoardCommentary,
//     setInvestorGuidanceAndBoardCommentary,
//   ] = useState([]);
//   const [revenueBreakdown, setRevenueBreakdown] = useState([]);

//   // ── master shared state ───────────────────────────────────────────────────
//   const [selectedCompetitors, setSelectedCompetitors] = useState([]);
//   const [competitorOptions, setCompetitorOptions] = useState([]);
//   const [financialData, setFinancialData] = useState([]);
//   const [loadingFinancials, setLoadingFinancials] = useState(false);

//   const resolvedClientName =
//     admin_roles.includes(user?.growth_iq_role_name) && selectedClient
//       ? selectedClient
//       : user?.company_name_for_growth_iq;

//   const { loading, data, error } = useSelector(
//     (state) => state.corporateAndOrgStructureReducer
//   );
//   const { data: competitorList } = useSelector(
//     (state) => state.competitorListReducer
//   );

//   const defaultCompetitors =
//     competitorList?.result?.map((comp) => ({
//       label: comp.company,
//       value: comp.vendor_company_id,
//     })) || [];

//   // ── scroll to top ─────────────────────────────────────────────────────────
//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   }, []);

//   // ── load page dimension data ──────────────────────────────────────────────
//   useEffect(() => {
//     dispatch(
//       submitCorporateAndOrgStructureRequest(
//         "Financial Performance & Strategy",
//         clientName
//       )
//     );
//   }, []);

//   useEffect(() => {
//     setHeadlineFinancialMetrics(
//       getAllSubdimensionMatches(data, "Headline Financial Metrics")
//     );
//     setPricingAndCostStructures(
//       getAllSubdimensionMatches(data, "Pricing & Cost Structures")
//     );
//     setInvestorGuidanceAndBoardCommentary(
//       getAllSubdimensionMatches(data, "Investor Guidance & Board Commentary")
//     );
//     setRevenueBreakdown(getAllSubdimensionMatches(data, "Revenue Breakdown"));
//     const { positive, negative, sowhat } = getAllPageInsights(data);
//     setPagePositives(positive || []);
//     setPageNegatives(negative || []);
//     setPageSoWhat(sowhat || []);
//   }, [data]);

//   // ── reset when client changes ─────────────────────────────────────────────
//   useEffect(() => {
//     initializedRef.current = false;
//     setSelectedCompetitors([]);
//     setCompetitorOptions([]);
//     setFinancialData([]);
//   }, [resolvedClientName]);

//   // ── load competitor list ──────────────────────────────────────────────────
//   useEffect(() => {
//     dispatch(
//       submitCompetitorListRequest({
//         client: resolvedClientName,
//         user_id: user?.user_id,
//         user_type:
//           user?.demo === APP_CONFIG.market_iq_demo ? "MarketIQ" : "CompIQ",
//         user_role: user?.growth_iq_role_name,
//       })
//     );
//   }, [resolvedClientName, user, dispatch]);

//   /**
//    * saveHeatmapRecord
//    * Called by CompetitorHeatmapContainer with its local heatmapCompanies list.
//    * This ensures only the companies visible in the heatmap are persisted,
//    * not the full master selectedCompetitors list.
//    */
//   const saveHeatmapRecord = useCallback(
//     async (heatmapCompanies) => {
//       const list = heatmapCompanies.filter(
//         (item) => item?.value && item?.label
//       );
//       if (!list.length) return;
//       try {
//         await saveUserHeatmapRecord({
//           user_id: user?.user_id,
//           client_name: resolvedClientName,
//           companies: list.map((item) => ({
//             company_id: item.value,
//             company_name: item.label,
//           })),
//         });
//       } catch (err) {
//         console.error("Save heatmap record error:", err);
//       }
//     },
//     [user, resolvedClientName]
//   );

//   /**
//    * fetchFinancials
//    * Fetches financial data for the given list (or selectedCompetitors).
//    * Does NOT call saveUserHeatmapRecord — that is now handled separately
//    * via saveHeatmapRecord so the child can pass its local heatmapCompanies.
//    *
//    * Exception: on initial load (no saved record), we pass the fallback list
//    * directly and also save it — handled inside the init() block below.
//    */
//   const fetchFinancials = useCallback(
//     async (competitorArg) => {
//       const list = Array.isArray(competitorArg)
//         ? competitorArg
//         : selectedCompetitors;
//       if (!list.length) return;

//       setLoadingFinancials(true);
//       try {
//         const result = await fetchMultipleFinancials(list);
//         const merged = result.map((apiResp, index) => ({
//           vendor_company_id: list[index]?.value,
//           company_name: list[index]?.label,
//           metrics: transformFinancialData(apiResp),
//         }));
//         setFinancialData(merged);
//       } catch (err) {
//         console.error("Financial fetch error:", err);
//       }
//       setLoadingFinancials(false);
//     },
//     [selectedCompetitors, user, resolvedClientName]
//   );

//   // ── initial load: restore saved heatmap record ────────────────────────────
//   useEffect(() => {
//     if (initializedRef.current || !competitorList) return;
//     initializedRef.current = true;

//     const init = async () => {
//       const fallbackList = [...defaultCompetitors];
//       try {
//         const res = await getUserHeatmapRecord({
//           user_id: user?.user_id,
//           client_name: resolvedClientName,
//         });
//         const saved =
//           res?.companies?.map((item) => ({
//             value: item.company_id,
//             label: item.company_name,
//           })) || [];

//         if (saved.length) {
//           // Saved record exists — restore it, no need to re-save
//           setSelectedCompetitors(saved);
//           setCompetitorOptions(mergeUniqueCompanies(saved, fallbackList));
//           fetchFinancials(saved);
//           return;
//         }

//         // No saved record — use fallback and save it as the initial record
//         setSelectedCompetitors(fallbackList);
//         setCompetitorOptions(fallbackList);
//         if (fallbackList.length) {
//           // Save the default list as the initial heatmap record
//           await saveUserHeatmapRecord({
//             user_id: user?.user_id,
//             client_name: resolvedClientName,
//             companies: fallbackList
//               .filter((item) => item?.value && item?.label)
//               .map((item) => ({
//                 company_id: item.value,
//                 company_name: item.label,
//               })),
//           });
//           fetchFinancials(fallbackList);
//         }
//       } catch (err) {
//         setSelectedCompetitors(fallbackList);
//         setCompetitorOptions(fallbackList);
//         if (fallbackList.length) fetchFinancials(fallbackList);
//       }
//     };

//     init();
//   }, [
//     competitorList,
//     defaultCompetitors,
//     user,
//     resolvedClientName,
//     fetchFinancials,
//   ]);

//   const handleAiConversation = () => console.log("AI conversation clicked");
//   const handleDownload = () => console.log("Download clicked");

//   const actions = [
//     {
//       type: "conversation",
//       title: "Conversation",
//       onClick: () => setShowConversationModal((prev) => !prev),
//     },
//     { type: "download", title: "Download", onClick: handleDownload },
//   ];

//   return (
//     <div className="financial_wrapper">
//       <div className="px-3">
//         <CompetitorHeatmapContainer
//           selectedClient={selectedClient}
//           selectedCompetitors={selectedCompetitors}
//           setSelectedCompetitors={setSelectedCompetitors}
//           competitorOptions={competitorOptions}
//           setCompetitorOptions={setCompetitorOptions}
//           financialData={financialData}
//           loadingFinancials={loadingFinancials}
//           fetchFinancials={fetchFinancials}
//           saveHeatmapRecord={saveHeatmapRecord}
//           defaultCompetitors={defaultCompetitors}
//         />
//       </div>

//       <div className="channel_contribution_block">
//         <GroupedBarChart
//           financialData={financialData}
//           competitorOptions={selectedCompetitors}
//         />
//       </div>
//     </div>
//   );
// }

// export default FinancialPerformance;

import React, { useEffect, useState, useCallback, useRef } from "react";
import "./FinancialPerformance.css";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  submitCorporateAndOrgStructureFailure,
  submitCorporateAndOrgStructureRequest,
} from "../../../../store/features/actions/corporateAndOrgStructureActions";
import useActiveScrollSection from "../../../../hooks/useActiveScrollSection";
import * as FeatherIcon from "react-feather";
import {
  getAllPageInsights,
  getAllSubdimensionMatches,
} from "../../../../services/commonService";
import {
  fetchMultipleFinancials,
  saveUserHeatmapRecord,
  getUserHeatmapRecord,
} from "../../../../services/accIqService";
import { submitCompetitorListRequest } from "../../../../store/features/actions/competitorListActions";
import { useUser } from "../../../../context/UserContext";
import APP_CONFIG from "../../../../config/appConfig";

import HeadlineFinancialMetrics from "./HeadlineFinancialMetrics";
import PricingAndCostStrucures from "./PricingAndCostStructures";
import InvestorGuidanceAndBoardCommentary from "./InvestorGuidanceAndBoardCommentary";
import RevenueBreakdown from "./RevenueBreakdown";
import TopRightActionLinks from "../TopRightActionLinks";
import InsightBlock from "../InsightBlock";
import GenericOverviewSideCard from "../../genericComponents/GenericOverviewSideCard";
import AIChat from "../../Chat/AiChat";
import GenericTableSkeleton from "../../skeletons/tableSkeleton/genericTableSkeleton";
import KeyCompetitorsTable from "../KeyCompetitorsTable";
import CompetitorHeatmapContainer from "../CompetitorHeatmapContainer";
import GroupedBarChart from "../../GroupedBarChart";
import MultiLineChart from "../../../MultiLineChart";

const admin_roles = ["ROLE_MNM_SUBSCRIBER", "ROLE_ACCOUNT_MANAGER"];

// const transformFinancialData = (apiResponse) => {
//   if (!apiResponse || !Array.isArray(apiResponse.rawFinancials)) return [];
//   return apiResponse.rawFinancials.map((metricBlock) => {
//     const sorted =
//       metricBlock.data
//         ?.filter((d) => d.value !== "Data Unavailable")
//         ?.sort((a, b) => Number(b.year) - Number(a.year)) || [];
//     return {
//       metric: metricBlock._id,
//       value: sorted.length ? Number(sorted[0].value) : null,
//     };
//   });
// };

const transformFinancialData = (apiResponse) => {
  if (!apiResponse || !Array.isArray(apiResponse.rawFinancials)) return [];
  return apiResponse.rawFinancials.map((metricBlock) => {
    const sorted =
      metricBlock.data
        ?.filter((d) => d.value !== "Data Unavailable")
        ?.sort((a, b) => Number(b.year) - Number(a.year)) || [];
    const rawValue = sorted.length ? Number(sorted[0].value) : null;
    return {
      metric: metricBlock._id,
      // value: rawValue !== null ? rawValue / 1e9 : null,
      // value: rawValue !== null ? rawValue / 100000 : null,
      value: rawValue !== null ? rawValue : null,
    };
  });
};

const mergeUniqueCompanies = (...arrays) => {
  const map = new Map();
  arrays.flat().forEach((item) => {
    if (item?.value) map.set(item.value, item);
  });
  return Array.from(map.values());
};

function FinancialPerformance({
  activeSubKey,
  setActiveSubKey,
  selectedClient,
}) {
  const { clientName, competitorName } = useParams();
  const dispatch = useDispatch();
  const { user } = useUser();
  const initializedRef = useRef(false);

  // ── page-level insight state ───────────────────────────────────────────────
  const [showConversationModal, setShowConversationModal] = useState(false);
  const [pagePositives, setPagePositives] = useState([]);
  const [pageNegatives, setPageNegatives] = useState([]);
  const [pageSoWhat, setPageSoWhat] = useState([]);
  const [headlineFinancialMetrics, setHeadlineFinancialMetrics] = useState([]);
  const [pricingAndCostStructures, setPricingAndCostStructures] = useState([]);
  const [
    investorGuidanceAndBoardCommentary,
    setInvestorGuidanceAndBoardCommentary,
  ] = useState([]);
  const [revenueBreakdown, setRevenueBreakdown] = useState([]);
  const [unFormattedApiResponse, setUnformattedApiResponse] = useState([]);

  // ── master shared state ───────────────────────────────────────────────────
  const [selectedCompetitors, setSelectedCompetitors] = useState([]);
  const [competitorOptions, setCompetitorOptions] = useState([]);
  const [financialData, setFinancialData] = useState([]);
  const [loadingFinancials, setLoadingFinancials] = useState(false);

  // ###################################################
  const heatmapRef = useRef(null);
  const groupedBarChartRef = useRef(null);
  const multilineChartRef = useRef(null);
  const programmaticScrollRef = useRef(false);

  const sectionMap = {
    heatmapTab: heatmapRef,
    groupedBarChartTab: groupedBarChartRef,
    multilineChartTab: multilineChartRef,
  };

  const { showScrollTop, scrollToTop } = useActiveScrollSection(
    sectionMap,
    activeSubKey,
    setActiveSubKey,
    programmaticScrollRef,
    financialData
  );

  // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // useEffect(() => {
  //   if (!activeSubKey) return;

  //   const sectionRef = sectionMap[activeSubKey];
  //   if (sectionRef?.current) {
  //     // mark as programmatic scroll so scroll-spy ignores this movement
  //     programmaticScrollRef.current = true;

  //     const yOffset = -100;
  //     const y =
  //       sectionRef.current.getBoundingClientRect().top +
  //       window.scrollY +
  //       yOffset;

  //     window.scrollTo({ top: y, behavior: "smooth" });

  //     // clear the flag after animation; tune timeout to match your animation time
  //     const t = setTimeout(() => {
  //       programmaticScrollRef.current = false;
  //     }, 700);

  //     return () => clearTimeout(t);
  //   }
  // }, [activeSubKey]);

  const scrollToSection = (key) => {
    const sectionRef = sectionMap[key];

    if (sectionRef?.current) {
      programmaticScrollRef.current = true;

      sectionRef.current.scrollIntoView({
        behavior: "instant",
        block: "start",
      });

      setTimeout(() => {
        programmaticScrollRef.current = false;
      }, 700);
    }
  };

  useEffect(() => {
    if (!activeSubKey) return;

    scrollToSection(activeSubKey);
  }, [activeSubKey]);

  // +++++++++++++++++++++++++++++++++++++++++++++
  // USEEFFECT FOR UPDATING LEFT NAVIGATION LINK ON SCROLL

  // useEffect(() => {
  //   let scrollTimeout = null;
  //   let ticking = false;

  //   const handleScroll = () => {
  //     if (programmaticScrollRef.current) return; // ignore programmatic scrolls
  //     if (ticking) return;
  //     ticking = true;

  //     window.requestAnimationFrame(() => {
  //       // Clear previous timeout (debounce)
  //       if (scrollTimeout) clearTimeout(scrollTimeout);

  //       // Wait until user stops scrolling for 200ms
  //       scrollTimeout = setTimeout(() => {
  //         const scrollPosition = window.scrollY + 120; // offset for header, etc.
  //         let currentKey = null;

  //         Object.entries(sectionMap).forEach(([key, ref]) => {
  //           if (!ref.current) return;
  //           const sectionTop = ref.current.offsetTop;
  //           const sectionHeight = ref.current.offsetHeight;

  //           // Check if scroll is within this section
  //           if (
  //             scrollPosition >= sectionTop &&
  //             scrollPosition < sectionTop + sectionHeight
  //           ) {
  //             currentKey = key;
  //           }
  //         });

  //         // update nav only if different
  //         if (currentKey && currentKey !== activeSubKey) {
  //           setActiveSubKey(currentKey);
  //         }
  //       }, 200); // change nav only after 200ms of no scrolling

  //       ticking = false;
  //     });
  //   };

  //   window.addEventListener("scroll", handleScroll, { passive: true });

  //   // run once on mount
  //   handleScroll();

  //   return () => {
  //     window.removeEventListener("scroll", handleScroll);
  //     if (scrollTimeout) clearTimeout(scrollTimeout);
  //   };
  // }, [activeSubKey, setActiveSubKey]);

  // USEEFFECT FOR UPDATING LEFT NAVIGATION LINK ON SCROLL
  // +++++++++++++++++++++++++++++++++++++++++++++
  // ###################################################

  const resolvedClientName =
    admin_roles.includes(user?.growth_iq_role_name) && selectedClient
      ? selectedClient
      : user?.company_name_for_growth_iq;

  const { loading, data, error } = useSelector(
    (state) => state.corporateAndOrgStructureReducer
  );
  const { data: competitorList } = useSelector(
    (state) => state.competitorListReducer
  );

  const defaultCompetitors =
    competitorList?.result?.map((comp) => ({
      label: comp.company,
      value: comp.vendor_company_id,
    })) || [];

  // ── scroll to top ─────────────────────────────────────────────────────────
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // ── load page dimension data ──────────────────────────────────────────────
  useEffect(() => {
    dispatch(
      submitCorporateAndOrgStructureRequest(
        "Financial Performance & Strategy",
        clientName
      )
    );
  }, []);

  useEffect(() => {
    setHeadlineFinancialMetrics(
      getAllSubdimensionMatches(data, "Headline Financial Metrics")
    );
    setPricingAndCostStructures(
      getAllSubdimensionMatches(data, "Pricing & Cost Structures")
    );
    setInvestorGuidanceAndBoardCommentary(
      getAllSubdimensionMatches(data, "Investor Guidance & Board Commentary")
    );
    setRevenueBreakdown(getAllSubdimensionMatches(data, "Revenue Breakdown"));
    const { positive, negative, sowhat } = getAllPageInsights(data);
    setPagePositives(positive || []);
    setPageNegatives(negative || []);
    setPageSoWhat(sowhat || []);
  }, [data]);

  // ── reset when client changes ─────────────────────────────────────────────
  useEffect(() => {
    initializedRef.current = false;
    setSelectedCompetitors([]);
    setCompetitorOptions([]);
    setFinancialData([]);
  }, [resolvedClientName]);

  // ── load competitor list ──────────────────────────────────────────────────
  useEffect(() => {
    dispatch(
      submitCompetitorListRequest({
        client: resolvedClientName,
        user_id: user?.user_id,
        user_type:
          user?.demo === APP_CONFIG.market_iq_demo ? "MarketIQ" : "CompIQ",
        user_role: user?.growth_iq_role_name,
      })
    );
  }, [resolvedClientName, user, dispatch]);

  /**
   * saveHeatmapRecord
   * Called by CompetitorHeatmapContainer with its local heatmapCompanies list.
   * This ensures only the companies visible in the heatmap are persisted,
   * not the full master selectedCompetitors list.
   */
  const saveHeatmapRecord = useCallback(
    async (heatmapCompanies) => {
      const list = heatmapCompanies.filter(
        (item) => item?.value && item?.label
      );
      if (!list.length) return;
      try {
        await saveUserHeatmapRecord({
          user_id: user?.user_id,
          client_name: resolvedClientName,
          companies: list.map((item) => ({
            company_id: item.value,
            company_name: item.label,
          })),
        });
      } catch (err) {
        console.error("Save heatmap record error:", err);
      }
    },
    [user, resolvedClientName]
  );

  /**
   * fetchFinancials
   * Fetches financial data for the given list (or selectedCompetitors).
   * Does NOT call saveUserHeatmapRecord — that is now handled separately
   * via saveHeatmapRecord so the child can pass its local heatmapCompanies.
   *
   * Exception: on initial load (no saved record), we pass the fallback list
   * directly and also save it — handled inside the init() block below.
   */
  const fetchFinancials = useCallback(
    async (competitorArg) => {
      const list = Array.isArray(competitorArg)
        ? competitorArg
        : selectedCompetitors;
      if (!list.length) return;

      setLoadingFinancials(true);
      try {
        const result = await fetchMultipleFinancials(list);

        setUnformattedApiResponse(result);
        const merged = result.map((apiResp, index) => ({
          vendor_company_id: list[index]?.value,
          company_name: list[index]?.label,
          metrics: transformFinancialData(apiResp),
        }));
        setFinancialData(merged);
      } catch (err) {
        console.error("Financial fetch error:", err);
      }
      setLoadingFinancials(false);
    },
    [selectedCompetitors, user, resolvedClientName]
  );

  // ── initial load: restore saved heatmap record ────────────────────────────
  useEffect(() => {
    if (initializedRef.current || !competitorList) return;
    initializedRef.current = true;

    const init = async () => {
      const fallbackList = [...defaultCompetitors];
      try {
        const res = await getUserHeatmapRecord({
          user_id: user?.user_id,
          client_name: resolvedClientName,
        });
        const saved =
          res?.companies?.map((item) => ({
            value: item.company_id,
            label: item.company_name,
          })) || [];

        if (saved.length) {
          // Saved record exists — restore it, no need to re-save
          setSelectedCompetitors(saved);
          setCompetitorOptions(mergeUniqueCompanies(saved, fallbackList));
          fetchFinancials(saved);
          return;
        }

        // No saved record — use fallback and save it as the initial record
        setSelectedCompetitors(fallbackList);
        setCompetitorOptions(fallbackList);
        if (fallbackList.length) {
          // Save the default list as the initial heatmap record
          await saveUserHeatmapRecord({
            user_id: user?.user_id,
            client_name: resolvedClientName,
            companies: fallbackList
              .filter((item) => item?.value && item?.label)
              .map((item) => ({
                company_id: item.value,
                company_name: item.label,
              })),
          });
          fetchFinancials(fallbackList);
        }
      } catch (err) {
        setSelectedCompetitors(fallbackList);
        setCompetitorOptions(fallbackList);
        if (fallbackList.length) fetchFinancials(fallbackList);
      }
    };

    init();
  }, [
    competitorList,
    defaultCompetitors,
    user,
    resolvedClientName,
    fetchFinancials,
  ]);

  const handleAiConversation = () => console.log("AI conversation clicked");
  const handleDownload = () => console.log("Download clicked");

  const actions = [
    {
      type: "conversation",
      title: "Conversation",
      onClick: () => setShowConversationModal((prev) => !prev),
    },
    { type: "download", title: "Download", onClick: handleDownload },
  ];

  return (
    <div className="financial_wrapper">
      {/* <div className="px-3" ref={heatmapRef}> */}
      <div className="" ref={heatmapRef}>
        <CompetitorHeatmapContainer
          selectedClient={selectedClient}
          selectedCompetitors={selectedCompetitors}
          setSelectedCompetitors={setSelectedCompetitors}
          competitorOptions={competitorOptions}
          setCompetitorOptions={setCompetitorOptions}
          financialData={financialData}
          loadingFinancials={loadingFinancials}
          fetchFinancials={fetchFinancials}
          saveHeatmapRecord={saveHeatmapRecord}
          defaultCompetitors={defaultCompetitors}
        />
      </div>

      <div className="channel_contribution_block mt-4" ref={groupedBarChartRef}>
        <GroupedBarChart
          financialData={financialData}
          competitorOptions={selectedCompetitors}
        />
      </div>

      <div className="channel_contribution_block mt-4" ref={multilineChartRef}>
        <MultiLineChart
          financialData={unFormattedApiResponse}
          competitorOptions={selectedCompetitors}
        />
      </div>

      {showScrollTop && (
        <button className="scroll-top-btn" onClick={scrollToTop}>
          {/* ↑ */}
          <FeatherIcon.ChevronUp />
        </button>
      )}
    </div>
  );
}

export default FinancialPerformance;
